import { render, staticRenderFns } from "./ChangeClicker.vue?vue&type=template&id=2d158ac5&scoped=true&"
import script from "./ChangeClicker.vue?vue&type=script&lang=ts&"
export * from "./ChangeClicker.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeClicker.vue?vue&type=style&index=0&id=2d158ac5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d158ac5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
